import { InjectionToken } from '@angular/core';
import { AddonGroup, AddonNode } from '../../../model';
import { Occ } from '../../../occ';
import { Converter } from '../../../util/converter.service';

export const ADDON_GROUP_NORMALIZER = new InjectionToken<Converter<Occ.CatalogAddonGroup, AddonGroup>>('AddonGroupNormalizer');
export const ADDON_NODE_NORMALIZER = new InjectionToken<Converter<Occ.CatalogAddonNode, AddonNode>>('AddonNodeNormalizer');
